import React, { useContext } from "react";
import { DataTable } from "@sscs/ui";
import { ReportContext } from "../../context";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import SecretDetails from "./SecretDetails";
import styles from "./secretsTable.module.scss";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "status",
        label: "Status",
        sortProperty: "status",
        sortId: "secrets-sort-status",
        headerClassName: styles["status-column"],
        width: "140px",
    },
    { id: "liveness", label: "Liveness", width: "90px" },
    {
        id: "exposure",
        label: "Exposure",
        sortProperty: "exposure",
        sortId: "secrets-sort-exposure",
        startReverse: true,
        width: "190px",
    },
    {
        id: "service",
        label: "Service",
        sortProperty: "service",
        sortId: "secrets-sort-service",
        width: "250px",
    },
    { id: "secret", label: "Secret", width: "100%" },
    { id: "canary", label: "Canary", width: "80px" },
    { id: "audit", label: "Audit", width: "80px" },
];
const SecretsTable = ({ secrets, matchCount, endpointFilter, filters, status, pagination, handlePaginationChange, sort, handleSortChange, }) => {
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const scanTime = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.analysis_summary.scan_timestamp;
    return (React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, status: status, empty: { subject: "secrets", filters }, pagination: {
            id: "secrets-pagination",
            itemCount: matchCount,
            pagination,
            onChange: handlePaginationChange,
        } }, secrets.map((secret, index) => (React.createElement(SecretDetails, { key: secret.id, rowIndex: index, secret: secret, scanTime: scanTime, endpointLabelHighlight: endpointFilter || undefined })))));
};
export default SecretsTable;
//# sourceMappingURL=SecretsTable.js.map